"use client";

import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

/**
 * 3D-Bühne im Hintergrund + gestochen scharfer Code-Diff im Vordergrund.
 */
export default function Preview() {
  const [flipped, setFlipped] = useState(false);

  useEffect(() => {
    const id = setInterval(() => setFlipped((v) => !v), 2400);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      aria-hidden="true"
      className="relative flex h-full w-full items-center justify-center overflow-hidden rounded-2xl p-4 select-none"
      style={{ perspective: "900px" }}
    >
      <motion.div
        animate={{ scale: [1, 1.22, 1], opacity: [0.45, 0.85, 0.45] }}
        transition={{ duration: 4.5, repeat: Infinity }}
        className="pointer-events-none absolute left-1/2 top-1/2 h-40 w-56 -translate-x-1/2 -translate-y-1/2 rounded-full bg-gradient-to-r from-rose-500/25 via-sky-500/25 to-emerald-500/35 blur-3xl"
      />

      <div
        className="pointer-events-none absolute inset-x-[-20%] bottom-[-35%] h-[110%] opacity-45 dark:opacity-60"
        style={{
          transform: "rotateX(68deg)",
          maskImage:
            "radial-gradient(ellipse 65% 55% at 50% 50%, black 25%, transparent 80%)",
          WebkitMaskImage:
            "radial-gradient(ellipse 65% 55% at 50% 50%, black 25%, transparent 80%)",
        }}
      >
        <motion.div
          animate={{ backgroundPosition: ["0px 0px", "0px 28px"] }}
          transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
          className="h-full w-full bg-[linear-gradient(to_right,rgba(14,165,233,0.3)_1px,transparent_1px),linear-gradient(to_bottom,rgba(14,165,233,0.3)_1px,transparent_1px)] bg-[size:28px_28px]"
        />
      </div>

      {/* Gestochen scharfer Vordergrund */}
      <div className="relative z-10 flex w-56 flex-col gap-2.5 antialiased">
        <motion.div
          animate={{
            opacity: flipped ? 0.55 : 0.9,
            x: flipped ? -8 : 0,
          }}
          transition={{ type: "spring", stiffness: 260, damping: 22 }}
          className="flex items-center justify-between rounded-xl border border-rose-400/60 bg-white px-3.5 py-2 font-mono text-xs shadow-md dark:bg-zinc-900"
        >
          <span className="flex items-center gap-2 font-bold text-rose-500">
            <span className="rounded bg-rose-500/15 px-1.5 py-0.5 font-black">
              −
            </span>
            <span className="line-through">Frist: 14 Tage</span>
          </span>
        </motion.div>

        <motion.div
          animate={{ x: flipped ? 6 : 0, y: flipped ? -2 : 0 }}
          transition={{ type: "spring", stiffness: 280, damping: 20 }}
          className="flex items-center justify-between rounded-xl border border-emerald-400/80 bg-white px-3.5 py-2.5 font-mono text-xs shadow-[0_16px_32px_-4px_rgba(16,185,129,0.55)] dark:bg-zinc-900"
        >
          <span className="flex items-center gap-2 font-black text-emerald-600 dark:text-emerald-400">
            <span className="rounded bg-emerald-500 px-1.5 py-0.5 text-white shadow-[0_0_10px_#10b981]">
              +
            </span>
            <span>Frist: 30 Tage</span>
          </span>
          <span className="rounded bg-emerald-500/15 px-1.5 py-0.5 text-[9px] font-bold text-emerald-600 dark:text-emerald-400">
            Geändert
          </span>
        </motion.div>
      </div>
    </div>
  );
}
